const state = {
    header_color: '#333',
    logo: false,
    logo_active:false
}

const mutations = {
    SET_COLOR: (state, data) => {
        state.header_color = data;
    },
    SET_LOGO: (state, data) => {
        state.logo = data;
    },
    SET_LOGO_ACTIVE: (state, data) => {
        state.logo_active = data;
    },
  
}
const actions = {

}
export default {
    namespaced: true,
    state,
    mutations,
    actions
}